// reducer.js
import {
  CREATE_USER_REQUEST,
  FETCH_USERS_REQUEST,
  FETCH_USER_REQUEST,
  FETCH_USER_TICKETS_REQUEST,
  UPDATE_USER_REQUEST,
  DELETE_USER_REQUEST,
  CHANGE_PASSWORD_REQUEST,

  CREATE_USER_SUCCESS,
  FETCH_USERS_SUCCESS,
  FETCH_USER_SUCCESS,
  FETCH_USER_TICKETS_SUCCESS,
  UPDATE_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,

  CREATE_USER_FAILURE,
  FETCH_USERS_FAILURE,
  FETCH_USER_FAILURE,
  FETCH_USER_TICKETS_FAILURE,
  UPDATE_USER_FAILURE,
  DELETE_USER_FAILURE,
  CHANGE_PASSWORD_FAILURE,
} from './actions';

const initialState = {
  create_user: null,
  users: null,
  user: null,
  user_tickets: null,
  change_password: null,
  update_user: null,
  delete_user: null,
  loading: false,
  error: null,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USER_TICKETS_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case CHANGE_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_USER_SUCCESS:
      return { ...state, loading: false, create_user: action.payload };
    case FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case FETCH_USER_SUCCESS:
      return { ...state, loading: false, user: action.payload };
    case FETCH_USER_TICKETS_SUCCESS:
      return { ...state, loading: false, user_tickets: action.payload };
    case UPDATE_USER_SUCCESS:
      return { ...state, loading: false, update_user: action.payload };
    case DELETE_USER_SUCCESS:
      return { ...state, loading: false, delete_user: action.payload };
    case CHANGE_PASSWORD_SUCCESS:
      return { ...state, loading: false, change_password: action.payload };

    case CREATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_USER_TICKETS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CHANGE_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default UserReducer;
